const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
       
    },
    {
        title: 'Account No.',
        dataIndex: 'walletAccountNo',
     
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        
    },
    {
        title: 'Withdraw Type',
        dataIndex: 'withdrawType',
        
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        width: 100
    }
];

export default columns;